import { useState, useEffect } from 'react';

export function useAccountsByBank(bankId) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bankId) {
      setAccounts([]);
      setLoading(false);
      return;
    }

    const fetchAccounts = async () => {
      try {
        const response = await fetch('/api/accounts');
        if (response.ok) {
          const data = await response.json();
          const filtered = data.filter((acc) => acc.bank_id === bankId);
          setAccounts(filtered);
        }
      } catch (err) {
        console.error('Error fetching accounts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [bankId]);

  return { accounts, loading };
}
